import React, { useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import GenericFormDrawer from '../../../components/GenericFormDrawer';
import { inviteToPosting, searchPublishedPostings, fetchPostingLabel } from '../config/poolApi';

// "Pozisyona Davet Et" — seçili adaylara yayındaki bir ilanın başvuru bağlantısını
// e-postayla gönderir (`POST v1/ats-job-postings/{id}/invite`). İlan seçici YALNIZ
// `published` ilanları arar (sunucu başka durumu reddeder). `requisitionId` verilirse
// seçici o kadronun ilanlarıyla sınırlanır (havuz önerileri).
//
// Sonuç (gönderilen + atlananlar) `onResult`a gider; çekmece yalnız BAŞARIDA kapanır.
export default function InviteToPostingDrawer({
  open, onClose, candidateIds, poolId, requisitionId, onResult,
}) {
  const { t } = useTranslation();
  const count = (candidateIds || []).length;

  // TUZAK: `asyncSelect` YALNIZ `onSearch` okur — `asyncConfig` ölü alandır.
  const schema = useMemo(() => [
    {
      name: 'summary',
      type: 'notice',
      content: t('ats.candidatePool.inviteNotice', { count }),
    },
    {
      name: 'jobPostingId',
      label: t('ats.candidatePool.invitePosting'),
      type: 'asyncSelect',
      grid: 12,
      required: true,
      minChars: 0,
      description: t('ats.candidatePool.invitePostingHint'),
      onSearch: (q) => searchPublishedPostings(q, requisitionId),
      onGetById: fetchPostingLabel,
    },
  ], [t, count, requisitionId]);

  const handleSave = useCallback(async (values) => {
    if (!values.jobPostingId || count === 0) return false;
    const result = await inviteToPosting(values.jobPostingId, candidateIds, poolId);
    if (!result) return false;
    if (onResult) onResult(result);
    return true;
  }, [candidateIds, poolId, count, onResult]);

  return (
    <GenericFormDrawer
      open={open}
      onClose={onClose}
      title={t('ats.candidatePool.inviteTitle')}
      schema={schema}
      initialValues={null}
      onSave={handleSave}
    />
  );
}
